import React from "react";
import type { UploadProps } from "antd";
import { Button, Upload } from "antd";

import { ReactComponent as UploadIcon } from "../../assets/svgs/file-upload.svg";
import styles from "./input.module.css";

interface Props {
  label: string;
  asterisk: boolean;
  subLabel?: React.ReactNode;
  props?: UploadProps;
  fileSize?: number;
  name?: string;
}

const FileUpload: React.FC<Props> = ({
  label,
  asterisk,
  subLabel,
  props,
  fileSize,
  name,
}) => (
  <div>
    <label className={styles.uploadLabel}>
      {label} {asterisk && <span className={styles.asterisk}>*</span>}
    </label>

    <p className={styles.subLabel}>{subLabel}</p>

    <Upload {...props} className={styles.uploadDiv} name={name}>
      {!fileSize && (
        <Button className={styles.button}>
          <UploadIcon />
          <p className={styles.browse}>Browse File Here</p>
          <p>doc, docx, pdf, jpg, png</p>
        </Button>
      )}
    </Upload>
  </div>
);

export default FileUpload;
